var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("restore-backup")))]),
      _c(
        "w-card-content",
        [
          _vm.isSupport
            ? _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-input", {
                        attrs: {
                          label: _vm.$ct("restore-encryption-key"),
                          fancy: "",
                        },
                        model: {
                          value: _vm.encryptionKey,
                          callback: function ($$v) {
                            _vm.encryptionKey = $$v
                          },
                          expression: "encryptionKey",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "w-row",
            [
              _vm.file
                ? _c("w-col", { attrs: { xs: "12" } }, [
                    _c(
                      "div",
                      [
                        _vm._v(_vm._s(_vm.file.name) + " "),
                        _c(
                          "w-link",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.removeFile()
                              },
                            },
                          },
                          [_c("w-fa", { attrs: { icon: "times" } })],
                          1
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-file-upload", {
                    attrs: {
                      label: _vm.$ct("drop-here-backup"),
                      sending: _vm.isUploadingFile,
                      "allowed-extensions": ["wfbackup"],
                      "max-size": 10e9,
                    },
                    on: {
                      input: function ($event) {
                        return _vm.onFile($event)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: {
                disabled: !_vm.isValid || _vm.isUploadingFile,
                icon: "check",
              },
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }